import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/GaoDeMap/mapView.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/TAddressOnline.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('cell', {
    staticClass: "smy__map-address",
    attrs: {
      "border-intent": false
    },
    nativeOn: {
      "click": function ($event) {
        _vm.isShow = !_vm.isShow;
      }
    }
  }, [_c('div', {
    staticClass: "title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "smy__cell-right"
  }, [_c('div', {
    staticClass: "value-body",
    on: {
      "click": function ($event) {
        _vm.isShowXAddress = true;
      }
    }
  }, [_vm.isUsed ? _c('label', {
    staticClass: "value"
  }, [_vm._v(" " + _vm._s(_vm._f("realAddress")(_vm.addrType, _vm.selected)) + " ")]) : _c('label', {
    staticClass: "placeholder"
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")])]), _c('div', {
    staticClass: "right-btn"
  }, [_vm._t("right"), _c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        _vm.showtMapAddress = true;
      }
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/map-square-o34_34@3x.png"
    }
  }), _c('span', [_vm._v(i18n.tc("385"))])])], 2)]), _c(__unplugin_components_0, {
    attrs: {
      "address": _vm.defaultCode
    },
    on: {
      "on-change": _vm.onChange,
      "show-name": _vm.showName
    },
    model: {
      value: _vm.isShowXAddress,
      callback: function ($$v) {
        _vm.isShowXAddress = $$v;
      },
      expression: "isShowXAddress"
    }
  }), _c(__unplugin_components_1, {
    attrs: {
      "center": _vm.center
    },
    on: {
      "callback": _vm.selectMapAddress
    },
    model: {
      value: _vm.showtMapAddress,
      callback: function ($$v) {
        _vm.showtMapAddress = $$v;
      },
      expression: "showtMapAddress"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };